let t=[];function n(e){t.includes(e)||(t=[...t,e],console.warn(`${e} is experimental and may change in the future. It's not ready for production yet. Please use with caution.`))}export{n as warnExperimental};
//# sourceMappingURL=warn-experimental.js.map
